
// @ts-nocheck


export const localeCodes =  [
  "en-GB",
  "de-DE"
]

export const localeLoaders = {
  "en-GB": [
    {
      key: "locale_en_45GB_46ts_22e4677c",
      load: () => import("#nuxt-i18n/22e4677c" /* webpackChunkName: "locale_en_45GB_46ts_22e4677c" */),
      cache: false
    }
  ],
  "de-DE": [
    {
      key: "locale_de_45DE_46ts_0fd7326c",
      load: () => import("#nuxt-i18n/0fd7326c" /* webpackChunkName: "locale_de_45DE_46ts_0fd7326c" */),
      cache: false
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/2bccd8bd" /* webpackChunkName: "config_vueI18n_46config_46ts_2bccd8bd" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      name: "English",
      code: "en-GB",
      language: "en-GB",
      dir: "ltr",
      files: [
        {
          path: "/home/vsts/work/1/s/i18n/locales/en-GB.ts",
          cache: undefined
        }
      ]
    },
    {
      name: "Deutsch",
      code: "de-DE",
      language: "de-DE",
      dir: "ltr",
      files: [
        {
          path: "/home/vsts/work/1/s/i18n/locales/de-DE.ts",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "de-DE",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "./locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    name: "English",
    code: "en-GB",
    language: "en-GB",
    dir: "ltr",
    files: [
      {
        path: "/home/vsts/work/1/s/i18n/locales/en-GB.ts",
        cache: undefined
      }
    ]
  },
  {
    name: "Deutsch",
    code: "de-DE",
    language: "de-DE",
    dir: "ltr",
    files: [
      {
        path: "/home/vsts/work/1/s/i18n/locales/de-DE.ts",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/